import { render, staticRenderFns } from "./EditComment.vue?vue&type=template&id=03736695&scoped=true&"
import script from "./EditComment.vue?vue&type=script&lang=js&"
export * from "./EditComment.vue?vue&type=script&lang=js&"
import style0 from "./EditComment.vue?vue&type=style&index=0&id=03736695&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03736695",
  null
  
)

export default component.exports